import { render, staticRenderFns } from "./politicalMiningMap.vue?vue&type=template&id=048feaba&scoped=true"
import script from "./politicalMiningMap.vue?vue&type=script&lang=js"
export * from "./politicalMiningMap.vue?vue&type=script&lang=js"
import style0 from "./politicalMiningMap.vue?vue&type=style&index=0&id=048feaba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048feaba",
  null
  
)

export default component.exports